import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  Profile,
  SanitizedProfileSettingsParams,
  updateProfileSettings,
} from '@utils/backend-api/profileSettings';

import { PROFILE_SETTINGS_KEY } from './useProfile';

interface ProfileUpdateProps {
  userId: number;
  isSetting?: boolean;
}

export default function useProfileUpdate({ userId, isSetting }: ProfileUpdateProps) {
  const queryClient = useQueryClient();
  const [saveStatus, setSaveStatus] = useState('');
  const [showSave, setShowSave] = useState(false);
  const [error, setError] = useState('');
  const {
    mutate: saveProfile,
    data: profileData,
    isLoading: isSavingProfile,
  } = useMutation(
    async (values: SanitizedProfileSettingsParams) => await updateProfileSettings(userId, values),
    {
      onSuccess: (data: Profile) => {
        queryClient.setQueryData([PROFILE_SETTINGS_KEY], data);
        if (data.emailVerificationRequired) {
          window.location.href = '/email-confirmation';
        } else {
          if (isSetting) {
            toast.success('Your Profile updated successfully');
          } else {
            setShowSave(true);
            setSaveStatus('Saved');
            setTimeout(() => {
              setShowSave(false);
            }, 3000);
          }
        }
      },
      onError: (error: { message: string }) => {
        if (isSetting) {
          toast.error(error.message);
        }
        setError('Something went wrong');
        setSaveStatus('Something went wrong');
      },
    }
  );

  return { saveProfile, profileData, isSavingProfile, saveStatus, showSave, error };
}
